import { WorkflowWriteBackMode } from 'libs/end-to-end/src/types/databases/workflows/workflow-write-back-mode';
import { WriteBackToFountainStrategy } from 'libs/end-to-end/src/types/databases/workflows/strategies/fountain-write-back';
import z from 'zod';
import { SelectiveFilterStringBasedOption } from 'libs/end-to-end/src/selective-filtering/selective-filter-matching-option';

export const WorkflowApplicantStageChangeUpdateStrategy =
  WriteBackToFountainStrategy;

export type WorkflowApplicantStageChangeUpdateStrategy = z.infer<
  typeof WorkflowApplicantStageChangeUpdateStrategy
>;

export const WorkflowApplicantStageChangeRule = z.object({
  sourceStageMatch: SelectiveFilterStringBasedOption,
  targetStageMatch: SelectiveFilterStringBasedOption,
});

export type WorkflowApplicantStageChangeRule = z.infer<
  typeof WorkflowApplicantStageChangeRule
>;

/**
 * Details for a workflow that writes back promotion readiness explanation.
 */
export const WorkflowApplicantStageChangeUpdateDetails = z.object({
  type: z.literal('applicantStageChangeUpdateDetails'),

  /**
   * The strategy for writing back.
   */
  strategy: WorkflowApplicantStageChangeUpdateStrategy.optional(),

  stageChangeRules: WorkflowApplicantStageChangeRule.array(),

  /**
   * The mode for writing back.
   */
  mode: WorkflowWriteBackMode.optional(),

  /**
   * The minimum readiness rating for an employee to be considered for writing back.
   */
  minReadinessRating: z.number().optional(),

  /**
   * The maximum amount of readiness scores to write back. This is used to limit the amount of data
   * that is written back to the target system, mainly for testing purposes.
   */
  numberOfSamplesToSend: z.number().optional(),

  isNewFountainStageMapOn: z.boolean().default(false),
});

export type WorkflowApplicantStageChangeUpdateDetails = z.infer<
  typeof WorkflowApplicantStageChangeUpdateDetails
>;
